import React from 'react'
import SearchIcon from '@mui/icons-material/Search';
import { styled, alpha } from '@mui/material/styles';
import {
    Button,
    Box,
    AppBar,
    Paper,
    Toolbar,
    Typography,
    InputBase,
    IconButton,
    TableCell,
    TableRow,
} from '@mui/material'


const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    height: "30px",
    borderRadius: theme.shape.borderRadius,
    border: "1px solid #aaa",
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        // marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    width: '100%',
    '& .MuiInputBase-input': {
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

const SearchBox = ({ value = '', placeholder = 'Search…', handleSearch }) => {
    return (
        <Search>
            <SearchIconWrapper >
                <SearchIcon />
            </SearchIconWrapper >
            <StyledInputBase
                value={value}
                placeholder={placeholder}
                onChange={(e: any) => { handleSearch(e.target.value) }}
                inputProps={{ 'aria-label': 'search' }}
            />
        </Search>

    )
}

export default SearchBox